"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCartCycle = void 0;
const react_1 = require("react");
const utils_1 = require("../../utils");
const useGenericCycle_1 = require("../useGenericCycle");
const useReseller_1 = require("../useReseller");
const useCartCycle = ({ state, resellerSlug, businessUnit }, onCycleChanged) => {
    const isGeneric = (0, utils_1.isGenericReseller)(resellerSlug);
    const [cartCycle, setCartCycle] = (0, react_1.useState)();
    const { cycle: cycleGeneric, resolved: resolvedGenericCycle } = (0, useGenericCycle_1.useGenericCycle)({ state: state, businessUnit }, isGeneric);
    const { reseller, resolved: resolvedReseller } = (0, useReseller_1.useReseller)({ resellerSlug: resellerSlug, businessUnit }, !isGeneric);
    const currentCycle = (0, utils_1.getStorageCycle)();
    const resolved = isGeneric ? resolvedGenericCycle : resolvedReseller;
    const updateCycle = (incomingCycle) => {
        const incomingCycleNumber = String(incomingCycle.id || incomingCycle.cycle);
        if (currentCycle !== incomingCycleNumber) {
            onCycleChanged === null || onCycleChanged === void 0 ? void 0 : onCycleChanged(incomingCycleNumber);
            (0, utils_1.clearOrderList)();
        }
        (0, utils_1.setStorageCycle)(String(incomingCycleNumber));
        setCartCycle(Object.assign(Object.assign({}, incomingCycle), { cycle: incomingCycleNumber }));
    };
    const checkCycleGeneric = (0, react_1.useCallback)(() => {
        if (!resolvedGenericCycle || !cycleGeneric)
            return;
        updateCycle(cycleGeneric);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resolvedGenericCycle]);
    const checkCycleReseller = (0, react_1.useCallback)(() => {
        var _a, _b;
        if (!resolvedReseller ||
            !reseller ||
            !reseller.availableBusinessUnits ||
            !reseller.availableBusinessUnits[businessUnit] ||
            !((_a = reseller.availableBusinessUnits[businessUnit]) === null || _a === void 0 ? void 0 : _a.cycle)) {
            return;
        }
        updateCycle((_b = reseller.availableBusinessUnits[businessUnit]) === null || _b === void 0 ? void 0 : _b.cycle);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resolvedReseller]);
    (0, react_1.useEffect)(() => {
        if (!isGeneric) {
            checkCycleReseller();
            return;
        }
        checkCycleGeneric();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkCycleGeneric, checkCycleReseller]);
    return { cycle: cartCycle, resolved };
};
exports.useCartCycle = useCartCycle;
